// extracted by mini-css-extract-plugin
export default {"baseBody":"base_baseBody__JyTqW","fullPage":"base_fullPage__piUY0","contentContainer":"base_contentContainer__646KK"};